import { connect } from "react-redux";

import type { State } from "../../redux/reducer";
import type { Dispatch } from "../../redux/action";

const connected = Component => (
  mapStateToProps: (state: State) => Object,
  mapDispatchToProps?: (dispatch: Dispatch) => Object
) => connect(mapStateToProps, mapDispatchToProps)(Component);

export default connected;



// WEBPACK FOOTER //
// ./src/components/common/connected.js